import CreationDrawer from 'components/CreationForms/base/CreationDrawer';
import { COMPANY_NAME_TAKEN_ERROR } from 'components/CreationForms/fields/CompanyNameField';
import CompanyFormBody from 'components/CreationForms/forms/CompanyForm';
import { useCompanyForm } from 'components/CreationForms/forms/CompanyForm/useCompanyForm';

export interface AddCompanyDrawerProps {
  /** The name the company starts with. */
  initialName?: string;
  /** The contact the new company is assigned to, instead of only creating it. */
  prospectId?: string;
  /** Called with the new company once it's assigned to the contact. */
  onAssigned?: (accountId: string | undefined) => void;
  onClose: () => void;
}

/** "Add new company" drawer: creates a company, or creates one and assigns a contact to it. */
const AddCompanyDrawer = ({
  initialName = '',
  prospectId,
  onAssigned,
  onClose,
}: AddCompanyDrawerProps) => {
  const form = useCompanyForm({
    initialCompany: { name: initialName },
    prospectId,
    onAssigned,
    onClose,
  });

  return (
    <CreationDrawer
      title="Add new company"
      submitLabel={prospectId ? 'Add and assign' : 'Add'}
      isDirty={form.isDirty}
      isSubmitting={form.isSubmitting}
      submitDisabled={form.nameCheck.isChecking}
      submitDisabledReason={
        form.nameCheck.isTaken ? COMPANY_NAME_TAKEN_ERROR : null
      }
      onSubmit={() => form.handleSubmit()}
      onClose={onClose}
    >
      <CompanyFormBody form={form} />
    </CreationDrawer>
  );
};

export default AddCompanyDrawer;
